import type { Theme } from '@mui/material';

export const styles = {
  error: (theme: Theme) => ({
    color: theme.colors.error[600],
  }),
};
